module.exports = __webpack_public_path__ + "img/AEGEO_SPAS-intro.e969c9fb.jpg";